/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SensorDataRequestCreateDataTypeEnum } from './SensorDataRequestCreateDataTypeEnum';
import {
    SensorDataRequestCreateDataTypeEnumFromJSON,
    SensorDataRequestCreateDataTypeEnumFromJSONTyped,
    SensorDataRequestCreateDataTypeEnumToJSON,
    SensorDataRequestCreateDataTypeEnumToJSONTyped,
} from './SensorDataRequestCreateDataTypeEnum';
import type { DataProviderEnum } from './DataProviderEnum';
import {
    DataProviderEnumFromJSON,
    DataProviderEnumFromJSONTyped,
    DataProviderEnumToJSON,
    DataProviderEnumToJSONTyped,
} from './DataProviderEnum';

/**
 * Serializer for creating a sensor data request.
 * @export
 * @interface SensorDataRequestCreateRequest
 */
export interface SensorDataRequestCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SensorDataRequestCreateRequest
     */
    siteId: string;
    /**
     * 
     * @type {string}
     * @memberof SensorDataRequestCreateRequest
     */
    emissionRecordId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SensorDataRequestCreateRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SensorDataRequestCreateRequest
     */
    endDate?: Date;
    /**
     * 
     * @type {SensorDataRequestCreateDataTypeEnum}
     * @memberof SensorDataRequestCreateRequest
     */
    dataType?: SensorDataRequestCreateDataTypeEnum;
    /**
     * 
     * @type {DataProviderEnum}
     * @memberof SensorDataRequestCreateRequest
     */
    dataProvider?: DataProviderEnum;
}



/**
 * Check if a given object implements the SensorDataRequestCreateRequest interface.
 */
export function instanceOfSensorDataRequestCreateRequest(value: object): value is SensorDataRequestCreateRequest {
    if ((!('siteId' in (value as Record<string, any>)) && !('site_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteId'] === undefined && (value as Record<string, any>)['site_id'] === undefined)) return false;
    return true;
}

export function SensorDataRequestCreateRequestFromJSON(json: any): SensorDataRequestCreateRequest {
    return SensorDataRequestCreateRequestFromJSONTyped(json, false);
}

export function SensorDataRequestCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SensorDataRequestCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'siteId': json['site_id'],
        'emissionRecordId': json['emission_record_id'] == null ? undefined : json['emission_record_id'],
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'endDate': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'dataType': json['data_type'] == null ? undefined : SensorDataRequestCreateDataTypeEnumFromJSON(json['data_type']),
        'dataProvider': json['data_provider'] == null ? undefined : DataProviderEnumFromJSON(json['data_provider']),
    };
}

export function SensorDataRequestCreateRequestToJSON(json: any): SensorDataRequestCreateRequest {
    return SensorDataRequestCreateRequestToJSONTyped(json, false);
}

export function SensorDataRequestCreateRequestToJSONTyped(value?: SensorDataRequestCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site_id': value['siteId'],
        'emission_record_id': value['emissionRecordId'],
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString(),
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString(),
        'data_type': SensorDataRequestCreateDataTypeEnumToJSON(value['dataType']),
        'data_provider': DataProviderEnumToJSON(value['dataProvider']),
    };
}

